export const CLIENT_ROUTE = '/subscriptions';
export const API_ROUTE = '/api/subscription'
export const CLIENT_TITLE = 'Багц'